'use client';

import React from 'react';

import { motion } from 'framer-motion';

import styles from './styles.module.css';

interface CubeSpinnerProps {
	size?: number;
}

function CubeSpinner({ size = 100 }: CubeSpinnerProps) {
	return (
		<div>
			<div className={styles.loaderContent}>
				<div className={styles.cubeContainer}>
					<motion.div
						className={styles.cube}
						style={{ '--size': `${size}px` } as React.CSSProperties}
						animate={{
							rotate: [0, 90, 90, 180, 180, 0],
							rotateX: [0, 0, -90, -90, -180, -180],
							rotateY: [0, 0, 0, 90, 90, -180],
						}}
						transition={{ repeat: Infinity, duration: 3 }}
					>
						<div style={{ width: size, height: size }} />
						<div style={{ width: size, height: size }} />
						<div style={{ width: size, height: size }} />
						<div style={{ width: size, height: size }} />
						<div style={{ width: size, height: size }} />
						<div style={{ width: size, height: size }} />
					</motion.div>
				</div>
			</div>
		</div>
	);
}

export default CubeSpinner;
